export const API_URL = "https://goclub-production.up.railway.app";
export const API_EMAIL = "re_SmeKKCeX_QHtQ5iJ9vSrUYCPY1tobQJWP"

// https://goclub-production.up.railway.app
// http://localhost:8000

// Global logout function that can be set by AuthContext
let globalLogout = null;

export const setGlobalLogout = (logoutFunction) => {
  globalLogout = logoutFunction;
};

export const fetchWithAuth = async (url, options = {}) => {
    const token = localStorage.getItem('token');

    const isFormData = options.body instanceof FormData;

    const response = await fetch(url, {
        ...options,
        headers: {  
            ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
            'Authorization': `Bearer ${token}` 
        },
        credentials: 'include',
    });

    if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        
        // Check if the error is due to JWT expiration (401 Unauthorized or 403 Forbidden)
        if (response.status === 401) {
            // Clear local storage
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            
            // Trigger global logout if available
            if (globalLogout) {
                globalLogout();
            }
            
            // Show user-friendly notification (more elegant than alert)
            const notification = document.createElement('div');
            notification.style.cssText = `
                position: fixed;
                top: 20px;
                right: 20px;
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                color: white;
                padding: 16px 24px;
                border-radius: 12px;
                box-shadow: 0 8px 32px rgba(0,0,0,0.3);
                z-index: 10000;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                font-size: 14px;
                max-width: 300px;
                animation: slideIn 0.3s ease-out;
            `;
            notification.innerHTML = `
                <div style="display: flex; align-items: center; gap: 12px;">
                    <div style="width: 8px; height: 8px; background: #ff6b6b; border-radius: 50%;"></div>
                    <div>
                        <div style="font-weight: 600; margin-bottom: 4px;">Sesión Expirada</div>
                        <div style="opacity: 0.9; font-size: 13px;">Por favor, inicia sesión nuevamente.</div>
                    </div>
                </div>
            `;
            
            // Add CSS animation
            const style = document.createElement('style');
            style.textContent = `
                @keyframes slideIn {
                    from { transform: translateX(100%); opacity: 0; }
                    to { transform: translateX(0); opacity: 1; }
                }
            `;
            document.head.appendChild(style);
            
            document.body.appendChild(notification);
            
            // Remove notification after 4 seconds
            setTimeout(() => {
                if (notification.parentNode) {
                    notification.parentNode.removeChild(notification);
                }
            }, 4000);
            
            // Redirect to login page after a short delay
            setTimeout(() => {
                window.location.href = '/login';
            }, 1000);
            
            throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
        }
        
        throw new Error(error.detail || 'Ocurrió un error.');
    }

    return response.json();
};

export async function createEvent(eventData) {
  const response = await fetch(`${API_URL}/events/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(eventData),
  });
  return await response.json();
}

// Helper function to construct proper image URLs
export function getImageUrl(imageUrl) {
  if (!imageUrl) return null;
  
  // If it's already a full URL, return as is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }
  
  // If it's a relative URL starting with /api/images/, construct full URL
  if (imageUrl.startsWith('/api/images/')) {
    return `${API_URL}${imageUrl}`;
  }
  
  // For old format URLs (legacy support)
  if (imageUrl.startsWith('/events/images/')) {
    return `${API_URL}${imageUrl}`;
  }
  
  // Default: assume it's a relative path
  return `${API_URL}${imageUrl}`;
}